import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.contractText) + _vm._s(_vm.t('业务合同签署')))]), _vm.data.contract_type == _vm.$enum.mine.ContractTypeEnum.OVERSEA_LOCATION ? _c('p', [_vm._v(_vm._s(_vm.t('本合同需要盖两个章，点击盖章会同时完成两处盖章，请仔细查看合同该内容')))]) : _vm._e(), _c('div', {
    ref: "canvasBox",
    staticStyle: {
      "width": "900px",
      "margin": "0px auto"
    },
    attrs: {
      "id": "canvasBox"
    }
  }), _c('my-modal', {
    attrs: {
      "title": _vm.t('实名认证'),
      "width": 420
    },
    model: {
      value: _vm.authVisible,
      callback: function ($$v) {
        _vm.authVisible = $$v;
      },
      expression: "authVisible"
    }
  }, [_c('div', {
    staticClass: "ct auth-body"
  }, [_c('a-icon', {
    staticClass: "auth-icon",
    attrs: {
      "type": "safety-certificate",
      "theme": "twoTone"
    }
  }), _c('p', {
    staticClass: "auth-title"
  }, [_vm._v(_vm._s(_vm.t('实名认证')))]), _c('p', {
    staticClass: "auth-tip"
  }, [_vm._v(_vm._s(_vm.t('请在认证页面完成实名认证')))]), _c('p', {
    staticClass: "auth-tip"
  }, [_vm._v(_vm._s(_vm.t('认证成功后请点击盖章按钮完成签约')))])], 1), _c('div', {
    staticClass: "ct",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    staticClass: "mr-10",
    attrs: {
      "size": "large",
      "data-permission": "welcome_sign_contract_auth_cancel",
      "id": "welcome_sign_contract_auth_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleCancelAuth
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "data-permission": "welcome_sign_contract_go_auth",
      "id": "welcome_sign_contract_go_auth",
      "fbu-analyse-name": $t("\u53BB\u8BA4\u8BC1")
    },
    on: {
      "click": _vm.handleGoAuth
    }
  }, [_vm._v(_vm._s(_vm.t('去认证')))])], 1)]), _c('my-modal', {
    attrs: {
      "title": _vm.t('签约完成'),
      "width": 450
    },
    model: {
      value: _vm.goOnSignVisible,
      callback: function ($$v) {
        _vm.goOnSignVisible = $$v;
      },
      expression: "goOnSignVisible"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-icon', {
    staticClass: "success-icon",
    attrs: {
      "type": "check-circle"
    }
  })], 1), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.t('您已成功签署[{0}]合同。', [_vm.contractText])))]), _c('p', [_vm._v(_vm._s(_vm.t('还有[{0}]合同未签约。', [_vm.nextContractText])))])])], 1), _c('div', {
    staticClass: "ct",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "size": "large",
      "data-permission": "welcome_sign_contract_go_on_sign_cancel",
      "id": "welcome_sign_contract_go_on_sign_cancel",
      "fbu-analyse-name": $t("\u8FD4\u56DE")
    },
    on: {
      "click": function ($event) {
        _vm.goOnSignVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('返回')))]), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "size": "large",
      "type": "primary",
      "data-permission": "welcome_sign_contract_go_on_sign",
      "id": "welcome_sign_contract_go_on_sign",
      "fbu-analyse-name": $t("\u7EE7\u7EED\u7B7E\u7EA6")
    },
    on: {
      "click": _vm.handleGoOnSignUp
    }
  }, [_vm._v(_vm._s(_vm.t('继续签约')))])], 1)], 1), _c('my-modal', {
    attrs: {
      "title": _vm.t('签约完成'),
      "width": 450
    },
    model: {
      value: _vm.returnSignListVisible,
      callback: function ($$v) {
        _vm.returnSignListVisible = $$v;
      },
      expression: "returnSignListVisible"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-icon', {
    staticClass: "success-icon",
    attrs: {
      "type": "check-circle"
    }
  })], 1), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.t('您已成功签署[{0}]合同。', [_vm.contractText])))]), _c('p', [_vm._v(_vm._s(_vm.t('尚有[{0}]合同待审核。审核通过后，需要继续进行合同签约。全部合同签约完毕后，将可使用系统。', [_vm.nextContractText])))])])], 1), _c('div', {
    staticClass: "ct",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "size": "large",
      "type": "primary",
      "data-permission": "welcome_sign_contract_return_sign_list",
      "id": "welcome_sign_contract_return_sign_list",
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handleConfirmReturnSignList
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))])], 1)], 1), _c('my-modal', {
    attrs: {
      "title": _vm.t('签约完成'),
      "width": 450
    },
    model: {
      value: _vm.completeSignVisible,
      callback: function ($$v) {
        _vm.completeSignVisible = $$v;
      },
      expression: "completeSignVisible"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-icon', {
    staticClass: "success-icon",
    attrs: {
      "type": "check-circle"
    }
  })], 1), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.t('您已成功签署完所有合同，')))]), _c('p', [_vm._v(_vm._s(_vm.t('现在开启谷仓海外仓之旅吧！({0}s后自动跳转首页)', [_vm.countNum])))])])], 1), _c('div', {
    staticClass: "ct",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "size": "large",
      "type": "primary",
      "data-permission": "welcome_sign_contract_to_home",
      "id": "welcome_sign_contract_to_home",
      "fbu-analyse-name": $t("\u597D\u7684")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('好的')))])], 1)], 1), _vm.data.contract_state === _vm.$enum.mine.ContractStateEnum.SIGN_PENDING || _vm.data.contract_state === _vm.$enum.mine.ContractStateEnum.SIGNED_SELF ? _c('footer-tool', [_c('div', [_c('a-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "data-permission": "welcome_sign_contract_submit",
      "id": "welcome_sign_contract_submit",
      "disabled": _vm.isButtonDisabled,
      "loading": _vm.sealLoading,
      "fbu-analyse-name": $t("\u76D6\u7AE0")
    },
    on: {
      "click": _vm.handleSeal
    }
  }, [_vm._v(_vm._s(_vm.t('盖章')))]), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "size": "large",
      "data-permission": "welcome_sign_contract_cancel",
      "id": "welcome_sign_contract_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/welcome');
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))])], 1)]) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };